// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/blocks/status-dot.scss
// module id = 1078
// module chunks = 62